import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../SocketConnection";
import {
  Badge,
  Card,
  Col,
  Divider,
  Dropdown,
  Popover,
  Row,
  Segmented,
  Switch,
  Tabs,
  Tooltip,
  Typography,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { css } from "@emotion/css";
//import moment from "moment";
import dayjs from "dayjs";
import {
  getNotificatonAction,
  updateAllByUserNotificatonAction,
  updateNotificatonAction,
} from "../../store/action/admin/notificationsActions";
import NotificationIcon from "../../Theme/CustomIcons/Icons/Notification/NotificationIcon";
import MessageTextIcon from "../../Theme/CustomIcons/Icons/Emails,Messages/MessageTextIcon";
import ArrowRightIcon from "../../Theme/CustomIcons/Icons/Arrow/ArrowRightIcon";
import EmptyState from "../../Theme/EmptyStates/EmptyState";
import CircleSpin from "../../Theme/Components/Spin/CircleSpin";
import { TranslatorDashboardTag } from "../../languageTranslator/LanguageTranslatorTags";
import MoreEmptyState from "../../Theme/EmptyStates/MoreEmptyStates/MoreEmptyState";
import { toggleUserTabSwitchAction } from "../../store/action/user/tabSwitchAction";
// import { messages, onMessageListener } from "../push-notification";
import notificationSound from "./sounds/notification.mp3"; // Import the sound file
// import { onMessage } from "firebase/messaging";

const { TabPane } = Tabs;
const { Text } = Typography;
const badgeStyle = css`
  .ant-badge-status-dot {
    min-width: 16px;
    width: 16px !important;
    height: 16px !important;
    border-radius: 100%;
    border: 2px solid #f5f4f6;
  }
`;

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const notificationsList = useSelector((state) => state.notificationsList);
  const { notifyInfo } = notificationsList;
  const [showMarkRead, setMarkRead] = useState(true);
  const [showMarkReadNumbers, setMarkReadNumbers] = useState(0);

  const router = useNavigate();
  const dispatch = useDispatch();
  let companyId;
  let userId;
  const themeDefault = useSelector((state) => state.themeDefault);
  const getAnnouncementList = useSelector((state) => state.getAnnouncementList);
  const { getAnnounceLoading, getAnnounceInfo } = getAnnouncementList;
  if (sharedUserInfo?.payload?.type === "admin") {
    companyId = sharedUserInfo?.payload?.company?._id;
    userId = sharedUserInfo?.payload?.id;
  } else if (
    sharedUserInfo?.empCompanies &&
    sharedUserInfo?.empCompanies.length > 0
  ) {
    companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    userId = sharedUserInfo?.payload?.id;
  }
  let userType = "";
  if (sharedUserInfo?.payload?.type) {
    userType = sharedUserInfo.payload.type;
  } else if (sharedUserInfo?.type) {
    userType = sharedUserInfo.type;
  }

  const roleFeatures = sharedUserInfo?.userAccess || [];
  let companyLogo = "";
  if (userType === "admin") {
    companyLogo = sharedUserInfo?.payload?.company?.logo?.url || "";
  } else if (
    sharedUserInfo?.empCompanies &&
    sharedUserInfo.empCompanies.length > 0
  ) {
    companyLogo = sharedUserInfo.empCompanies[0]?.companyId?.logo?.url || "";
  }
  useEffect(() => {
    // if (!notifyInfo) {
    dispatch(getNotificatonAction());
    // }
  }, [notifications]);

  useEffect(() => {
    const handleNotification = (notification) => {
      setNotifications((prev) => [notification]);
    };

    // Set up notification listener
    socket.on("notification", handleNotification);

    // Clean up function to remove event listener
    return () => {
      socket.off("notification", handleNotification);
    };
  }, []);

  const notificationTone = new Audio(notificationSound);

  // useEffect(() => {
  // const handleNotification1 = (notification) => {
  //   playNotificationTone();
  //   setNotifications((prev) => [notification.notification]);
  //   // Optionally, you can display the notification directly
  //   // const { title, body } = notification.notification;
  //   // new Notification(title, { body });
  // };

  // onMessage(messages, (payload) => {
  //   handleNotification1(payload);
  // });

  // Set up Firebase push notification listener
  // const listenForPushNotifications = async () => {
  //   try {
  //     const payload = await onMessageListener();
  //     handleNotification1(payload);
  //   } catch (error) {
  //     console.error("Error receiving push notification:", error);
  //   }
  // };

  // // Start listening for push notifications
  // listenForPushNotifications();

  // Clean-up is not required here as onMessageListener doesn't set up a permanent listener like sockets
  // }, []);

  const playNotificationTone = () => {
    notificationTone.play();
  };

  const [items, setItems] = useState([]);

  useEffect(() => {
    const newItems = [];
    let markReadCount = 0;

    // Helper function to add items to newItems array
    const addItem = (item, markAsRead) => {
      newItems.push({
        _id: item._id,
        title: item.title,
        description: item.description,
        createdAt: item.createdAt,
        markAsRead: markAsRead,
      });
    };

    // Process items based on markAsRead flag
    const processItems = (items, markAsRead) => {
      items &&
        items.length > 0 &&
        items?.forEach((item) => {
          const finding = item.receiveTo?.find(
            (a) =>
              String(a.userId) === sharedUserInfo.payload.id &&
              a.markAsRead === markAsRead
          );
          if (finding) {
            // if (markAsRead === false) {
            //   markReadCount++;
            // }
            addItem(item, markAsRead);
          }
        });
    };

    // Process notifications based on showMarkRead flag
    if (showMarkRead === true) {
      processItems(notifications || [], false);
      notifyInfo &&
        notifyInfo.length > 0 &&
        notifyInfo
          ?.filter((notif) => companyId === String(notif.companyId))
          .forEach((notif) => {
            const finding = notif.receiveTo?.find(
              (a) =>
                String(a.userId) === sharedUserInfo.payload.id &&
                a.markAsRead === false
            );
            if (
              finding &&
              notifications &&
              notifications.length > 0 &&
              notifications.find((item) => item._id !== String(notif._id))
            ) {
              addItem(notif, false);
              markReadCount++;
            } else if (finding && notifications.length === 0) {
              addItem(notif, false);
              markReadCount++;
            }
          });
    } else if (showMarkRead === false) {
      processItems(notifications || [], true);
      notifyInfo &&
        notifyInfo.length > 0 &&
        notifyInfo
          ?.filter((notif) => companyId === String(notif.companyId))
          .forEach((notif) => {
            const finding = notif?.receiveTo?.find(
              (a) =>
                String(a.userId) === sharedUserInfo.payload.id &&
                a.markAsRead === true
            );
            if (
              finding &&
              notifications &&
              notifications.length > 0 &&
              notifications.find((item) => item._id !== String(notif._id))
            ) {
              addItem(notif, true);
            } else if (finding && notifications.length === 0) {
              addItem(notif, true);
            }
          });
    }

    // Sort newItems by createdAt
    newItems.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    // Update state variables
    setMarkReadNumbers(markReadCount);
    updateTabTitle(newItems.length);
    setItems(newItems);
  }, [notifyInfo, notifications, companyId, sharedUserInfo, showMarkRead]);

  const updateTabTitle = (count) => {
    // Original title of the page
    const originalTitle = "Max HR";
    document.title = count > 0 ? `(${count}) ${originalTitle}` : originalTitle;
  };

  const [companyAnnouncement, setCompanyAnnouncement] = useState([]);

  useEffect(() => {
    if (getAnnounceInfo && getAnnounceInfo.length > 0) {
      // Reverse the announcements and update state
      setCompanyAnnouncement([...getAnnounceInfo].reverse());
    }
  }, [getAnnounceInfo]); // Effect will run whenever getAnnounceInfo changes

  const onClicked = async (link, id, userId, markAsRead) => {
    const data = {
      notifyId: id,
      userId,
      markAsRead: markAsRead === true ? false : true,
    };
    await dispatch(updateNotificatonAction(data));
    router(link);
  };

  const onClickedAllNotify = async () => {
    const data = {
      userId: sharedUserInfo?.payload?.id,
      markAsRead: showMarkRead === true ? true : false,
    };
    await dispatch(updateAllByUserNotificatonAction(data));
  };
  const notification1 = () => {
    return (
      <Row
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "auto",
            marginBottom: "10px",
          }}
        >
          <Text>
            <TranslatorDashboardTag>Only show unread</TranslatorDashboardTag>{" "}
            <Switch
              size="small"
              defaultChecked
              onClick={(e) => setMarkRead(e)}
            />
          </Text>
        </Col>
        <Col span={24}>
          {items && items.length > 0 ? (
            <div
              style={{ width: "100%", maxHeight: "450px", overflowY: "auto" }}
            >
              {items.reverse().map((notif, index) => {
                const link = notif?.link
                  ? `${notif.link}${
                      notif?.action ? `?action=${notif.action}` : ""
                    }`
                  : "";
                if (notif?.markAsRead === false && showMarkRead === true) {
                  return (
                    <div
                      key={index}
                      onClick={() =>
                        onClicked(
                          link,
                          notif?._id,
                          sharedUserInfo?.payload?.id,
                          notif?.markAsRead
                        )
                      }
                      style={{ marginBottom: "5px", cursor: "pointer" }}
                    >
                      <div
                        style={{
                          padding: "15px 15px",
                          paddingTop: "5px",
                          borderRadius: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Text>{notif?.title}</Text>
                          {/* <Text style={{ fontSize: "10px", color: "grey" }}>
                            TITLE:
                          </Text> */}
                          <Text style={{ fontSize: "10px", color: "grey" }}>
                            {dayjs(notif?.createdAt).format("LLL")}
                          </Text>
                          <Badge
                            dot
                            className={badgeStyle}
                            status="success"
                          ></Badge>
                        </div>

                        <Text>{notif?.title}</Text>
                        {notif?.description && (
                          <div style={{ marginTop: "8px", display: "flex" }}>
                            {/* <Text style={{ fontSize: "10px", color: "grey" }}>
                              DESCRIPTION:
                            </Text> */}
                            <Text>{notif?.description}</Text>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                } else if (
                  notif?.markAsRead === true &&
                  showMarkRead === false
                ) {
                  return (
                    <div
                      key={index}
                      onClick={() =>
                        onClicked(
                          link,
                          notif?._id,
                          sharedUserInfo?.payload?.id,
                          notif?.markAsRead
                        )
                      }
                      style={{ marginBottom: "5px", cursor: "pointer" }}
                    >
                      <div
                        style={{
                          padding: "15px 15px",
                          paddingTop: "5px",
                          borderRadius: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Text>{notif?.title}</Text>
                          <Text style={{ fontSize: "10px", color: "grey" }}>
                            {dayjs(notif?.createdAt).format("LLL")}
                          </Text>
                        </div>
                        {notif?.description && (
                          <div style={{ marginTop: "8px" }}>
                            <Text>{notif?.description}</Text>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          ) : (
            <>
              {showMarkRead === false ? (
                <MoreEmptyState
                  type="MegaPhoneState"
                  size="small"
                  text={
                    <TranslatorDashboardTag>
                      No read notifications
                    </TranslatorDashboardTag>
                  }
                />
              ) : (
                <MoreEmptyState
                  type="MegaPhoneState"
                  size="small"
                  text={
                    <TranslatorDashboardTag>
                      No unread notifications
                    </TranslatorDashboardTag>
                  }
                />
              )}
            </>
          )}
          {items && items.length > 0 && (
            <>
              {showMarkRead === true ? (
                <div>
                  <hr
                    style={{
                      borderTop: "1px solid #f2f5f8",
                      marginTop: "5px",
                    }}
                  />
                  <Text
                    onClick={onClickedAllNotify}
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  >
                    <TranslatorDashboardTag>
                      Mark all as read
                    </TranslatorDashboardTag>
                  </Text>
                </div>
              ) : (
                <div>
                  <hr
                    style={{
                      borderTop: "1px solid #f2f5f8",
                      marginTop: "5px",
                    }}
                  />
                  <Text
                    onClick={onClickedAllNotify}
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  >
                    <TranslatorDashboardTag>
                      Mark all as unread
                    </TranslatorDashboardTag>
                  </Text>
                </div>
              )}
            </>
          )}
        </Col>
      </Row>
    );
  };
  const notification = () => {
    return (
      <Row
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "470px",
          width: "100%",
          overflow: "auto",
          ...(items && items.length > 0 ? {} : { justifyContent: "center" }),
        }}
      >
        <Col span={24}>
          {items && items.length > 0 ? (
            <div
              style={{ width: "100%", maxHeight: "450px", overflowY: "auto" }}
            >
              {items.reverse().map((notif, index) => {
                const link = notif?.link
                  ? `${notif.link}${
                      notif?.action ? `?action=${notif.action}` : ""
                    }`
                  : "";
                return (
                  <div
                    className={css`
                      border-bottom: ${themeDefault?.info?.newConfig
                        ?.cardborder};
                    `}
                    key={index}
                    onClick={() =>
                      onClicked(
                        link,
                        notif?._id,
                        sharedUserInfo?.payload?.id,
                        notif?.markAsRead
                      )
                    }
                    style={{ marginBottom: "5px", cursor: "pointer" }}
                  >
                    <div
                      style={{
                        padding: "15px 0px",
                        paddingTop: "5px",
                        borderRadius: "8px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Text>{notif?.title}</Text>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                        >
                          <Text style={{ fontSize: "10px", color: "grey" }}>
                            {dayjs(notif?.createdAt).format("LLL")}
                          </Text>
                          <Badge
                            dot
                            className={badgeStyle}
                            status="success"
                          ></Badge>
                        </div>
                      </div>

                      {notif?.description && (
                        <div style={{ marginTop: "8px", display: "flex" }}>
                          <Text>{notif?.description}</Text>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <MoreEmptyState
              type="MegaPhoneState"
              size="small"
              text={
                <TranslatorDashboardTag>
                  No Announcements
                </TranslatorDashboardTag>
              }
            />
          )}
        </Col>
      </Row>
    );
  };
  const announcements = () => {
    return (
      <Row
        gutter={[8, 8]}
        style={{
          maxHeight: "470px",
          overflow: "auto",
        }}
      >
        {getAnnounceLoading ? (
          <CircleSpin size={"large"} />
        ) : companyAnnouncement && companyAnnouncement.length > 0 ? (
          companyAnnouncement.map((_c, index) => (
            <Col
              span={24}
              key={index}
              style={{
                borderBottom: themeDefault?.info?.newConfig?.cardborder,
              }}
            >
              <div
                style={{
                  padding: "15px 15px",
                  paddingTop: "5px",
                  borderRadius: "8px",
                }}
              >
                <Row>
                  <Col span={24}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text>{_c?.title || "no title found"}</Text>
                      <Text style={{ fontSize: "10px", color: "grey" }}>
                        {_c?.createdAt
                          ? dayjs(_c?.createdAt).format("LLL")
                          : "no time found"}
                      </Text>
                    </div>
                    {/* <Text>{_c?.title}</Text> */}
                    {_c?.description && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <Text>{_c?.description}</Text>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          ))
        ) : (
          <MoreEmptyState
            type="MegaPhoneState"
            size="small"
            text={
              <TranslatorDashboardTag>No Announcements</TranslatorDashboardTag>
            }
          />
        )}
      </Row>
    );
  };
  const toggleUserTabSwitchList = useSelector(
    (state) => state.toggleUserTabSwitchList
  );
  const { toggleValue } = toggleUserTabSwitchList;

  const [label, setLabel] = useState(
    userType === "user" ? "Announcements" : "Notification"
  );
  return (
    <div
      className={css`
        .ant-popover .ant-popover-content .ant-popover-inner {
          padding: 20px 25px !important;
        }
        .antd-popover {
          z-index: 999 !important;
        }
        :where(.css-dev-only-do-not-override-1hiifmm).ant-tabs
          .ant-tabs-tab-btn
          .ant-tabs-tab-icon:not(:last-child) {
          margin-inline-end: 6px;
        }
        .icom {
        }
      `}
    >
      <Popover
        title={
          <Tabs
            defaultActiveKey={userType === "user" ? "2" : "1"}
            centered
            onChange={(key) =>
              setLabel(key === "1" ? "Notification" : "Announcements")
            }
            className={css`
              .ant-tabs-tab-btn {
                display: flex;
                gap: 4px;
                align-items: center;
                justify-content: center;
              }
            `}
          >
            {userType !== "user" && (
              <TabPane
                className={css`
                  :where(.css-dev-only-do-not-override-1hiifmm).ant-tabs
                    .ant-tabs-tab-btn
                    .ant-tabs-tab-icon:not(:last-child) {
                    margin-inline-end: 6px;
                  }
                `}
                tab={
                  <TranslatorDashboardTag>Notification</TranslatorDashboardTag>
                }
                key="1"
                icon={
                  <NotificationIcon
                    className={css`
                      font-size: clamp(12px, 1.2vw, 16px) !important;
                    `}
                  />
                }
              />
            )}
            <TabPane
              tab={
                <TranslatorDashboardTag>Announcements</TranslatorDashboardTag>
              }
              key="2"
              icon={
                <MessageTextIcon
                  className={css`
                    font-size: clamp(12px, 1.2vw, 16px) !important;
                  `}
                />
              }
            />
          </Tabs>
        }
        style={{ padding: "200px 250px" }}
        trigger="click"
        content={
          <div
            style={{
              width: "clamp(310px,22vw,410px)",
              minHeight: "500px",
              display: "flex",
              paddingTop: "0px",
              flexDirection: "column",
              justifyContent:
                label === "Notification" ? "flex-start" : "space-between",
            }}
          >
            <div
              style={{
                overflowX: "hidden",
                flex: "1",
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              {label === "Notification" ? notification() : announcements()}
            </div>
            {label === "Announcements" && (
              <>
                {userType === "user" ? (
                  <Link
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    to="/user/announcement"
                    className={css`
                      .anticon {
                        transition: color 0.3s ease-in-out;
                        color: ${themeDefault?.info?.newConfig
                          ?.color} !important;
                      }
                      .ant-typography {
                        transition: color 0.3s ease-in-out;
                        color: ${themeDefault?.info?.newConfig
                          ?.color} !important;
                      }
                      &:hover {
                        .anticon {
                          color: ${themeDefault?.info?.colorPrimary} !important;
                        }
                        .ant-typography {
                          color: ${themeDefault?.info?.colorPrimary} !important;
                        }
                      }
                    `}
                  >
                    <div
                      className={css`
                        cursor: pointer;
                        display: flex;
                        width: 100%;
                        justify-content: center;
                        border-top: ${themeDefault?.info?.newConfig
                          ?.cardborder};
                        align-items: center;
                        gap: 5px;
                        padding: 10px 0px;
                      `}
                    >
                      <Text>
                        {" "}
                        <TranslatorDashboardTag>
                          View All announcements
                        </TranslatorDashboardTag>
                      </Text>
                      <ArrowRightIcon size={"small"} />
                    </div>
                  </Link>
                ) : (
                  <Link
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    to={`/${
                      userType === "admin" || userType === "user"
                        ? userType
                        : "manager"
                    }/announcement`}
                    className={css`
                      .anticon {
                        transition: color 0.3s ease-in-out;
                        color: ${themeDefault?.info?.newConfig
                          ?.color} !important;
                      }
                      .ant-typography {
                        transition: color 0.3s ease-in-out;
                        color: ${themeDefault?.info?.newConfig
                          ?.color} !important;
                      }
                      &:hover {
                        .anticon {
                          color: ${themeDefault?.info?.colorPrimary} !important;
                        }
                        .ant-typography {
                          color: ${themeDefault?.info?.colorPrimary} !important;
                        }
                      }
                    `}
                  >
                    <div
                      className={css`
                        cursor: pointer;
                        display: flex;
                        width: 100%;
                        justify-content: center;
                        border-top: ${themeDefault?.info?.newConfig
                          ?.cardborder};
                        align-items: center;
                        gap: 5px;
                        padding: 10px 0px;
                      `}
                    >
                      <Text>
                        {" "}
                        <TranslatorDashboardTag>
                          View All announcements
                        </TranslatorDashboardTag>
                      </Text>
                      <ArrowRightIcon size={"small"} />
                    </div>
                  </Link>
                )}
              </>
            )}
          </div>
        }
        placement="bottomLeft"
      >
        <Tooltip
          title={<TranslatorDashboardTag>Notification</TranslatorDashboardTag>}
          placement="bottom"
        >
          <Badge count={showMarkReadNumbers}>
            <NotificationIcon
              className={css`
                cursor: pointer;
                font-size: clamp(10px, 1vw, 18px);
              `}
              style={{
                color: themeDefault?.info?.newConfig?.color,
              }}
            />
          </Badge>
        </Tooltip>
      </Popover>
    </div>
  );
};

export default Notifications;
